import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Public Pages Only
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/Login';
import RegisterPage from './pages/RegisterPage';
import PricingPage from './pages/PricingPage';
import FeaturesPage from './pages/FeaturesPage';
import PublicFaqPage from './pages/PublicFaqPage';
import EmbedContactForm from './pages/EmbedContactForm';
import PrivacyPage from './pages/PrivacyPage';  
import TermsPage from './pages/TermsPage';
import DataDeletionPage from './pages/DataDeletionPage';
import VoiceAgentPage from './pages/VoiceAgentPage';
import BookingPage from './pages/BookingPage';


// Components
import ScrollToTop from './components/ScrollToTop';
import UpdateAvailableSnackbar from './components/UpdateAvailableSnackbar';
import { startVersionCheck } from './utils/versionCheck';

// Create theme (same as original for consistency)
const theme = createTheme({
  palette: {
    primary: {
      main: '#145da0',
    },
    secondary: {
      main: '#06C755',
    },
    error: {
      main: '#8B0000',
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          // Add any global button styles here
        },
      },
    },
  },
});

function App() {
  // 啟動前端版本輪詢（只在 production build 生效）
  useEffect(() => {
    startVersionCheck();
  }, []);

  // 載入 Rebaz Web Chat Widget（全站共用）
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/api/web-chat/widget.js';
    document.body.appendChild(script);
    script.onload = () => {
      window.rebaz?.('init', { key: process.env.REACT_APP_WEB_CHAT_KEY || '' });
    };
    return () => {
      window.rebaz?.('destroy');
      if (script.parentNode) script.remove();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UpdateAvailableSnackbar />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Landing page - main public page */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Auth pages */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* Public information pages */}
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/faq-public" element={<PublicFaqPage />} />
          <Route path="/voice-agent" element={<VoiceAgentPage />} />

          {/* Legal pages - 新增 */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/data-deletion" element={<DataDeletionPage />} />
          
          {/* Embed page for WordPress iframe */}
          <Route path="/embed-contact-form" element={<EmbedContactForm />} />

          {/* Online Web Booking — 公開訂位頁 (feature_plans/090, rebaz.ai/r/:slug) */}
          <Route path="/r/:slug" element={<BookingPage />} />

          {/* Fallback - redirect unknown routes to landing page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;